const loader = function () {
    let counter = 0;
    return {
        show: function () {
            counter += 1;
            const ele: HTMLElement | null = document.getElementById('loaderDiv');
            if (ele) ele.style.display = 'block';
        },
        hide: function () {
            counter -= 1;
            if (counter < 1) {
                const ele: HTMLElement | null = document.getElementById('loaderDiv');
                if (ele) ele.style.display = 'none';
            }
        }
    }
}();

export default loader;